import React from "react";
import { Col, Row } from "react-bootstrap";
import { IoIosArrowBack } from "react-icons/io";
import {
  AuthHeadingText,
  TextBasic,
} from "../components/ThemeComponent/ThemeText";
import { Logo } from "../configs/svg.js";
import { useNavigate } from "react-router-dom";

export default function PublicLayout({
  hasBackButton = false,
  children,
  bg_image,
  heading,
  description,
}) {
  const navigate = useNavigate();
  const handleBackButtonClick = () => {
    navigate(-1);
  };
  return (
    <div className={"AccountLayout"}>
      <div className={"sectionContainer"}>
        <Row className={"row p-1"}>
          <Col
            md={6}
            className={"mediaContainer p-0 rounded-3"}
            style={{
              backgroundImage: `
                linear-gradient(180deg,rgba(0, 0, 0, 0.185) 0%,rgba(0, 0, 0, 0.717709) 67%,#000000 89.5%), 
                url(${bg_image})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          >
            <div className="h-75 w-85 d-flex flex-column justify-content-end text-start mb-4">
              <AuthHeadingText text={heading} className="mb-2 text-white" />
              <TextBasic text={description} className="mt-1 text-white" />
            </div>
          </Col>

          <Col md={6} className={"formContainer p-0"}>
            <Logo width={"187px"} height={"128.69px"} className={"image"} />
            <br />
            <div className={"card"}>
              <div className={"form"}>
                {hasBackButton && (
                  <div className="d-flex w-100 mb-2">
                    <div
                      className={"backButtonContainer"}
                      onClick={handleBackButtonClick}
                    >
                      <IoIosArrowBack />
                    </div>
                  </div>
                )}
                {children}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}
